// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"54811418","729":"dc812449"}[chunkId] + ".chunk.js";
};